import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import {
    Typography,
    Box,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Avatar,
} from "@mui/material";

function AddUserModal({ open, onClose, roleId, currentUsers, onAdded }) {
    const [allUsers, setAllUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        axios
            .get("/users/")
            .then((res) => {
                const available = res.data.filter(
                    (u) => !currentUsers.some((cu) => cu.id === u.id)
                );
                setAllUsers(available);
                setFilteredUsers(available);
            })
            .catch((err) => console.error("Error fetching users", err));
    }, [currentUsers]);

    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);
        setFilteredUsers(
            allUsers.filter(
                (u) =>
                    u.name.toLowerCase().includes(query) ||
                    u.email.toLowerCase().includes(query)
            )
        );
    };

    const handleSelect = (user) => {
        setSelectedUser(user);
    };

    const handleSubmit = () => {
        if (selectedUser) {
            axios
                .post(`/users/${selectedUser.id}/role/${roleId}`)
                .then(() => {
                    onAdded();
                    onClose();
                })
                .catch((err) => console.error("Error adding user", err));
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Add User to Role</DialogTitle>
            <DialogContent>
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Search users..."
                    value={searchQuery}
                    onChange={handleSearch}
                    margin="normal"
                />
                {filteredUsers.map((user) => (
                    <Box
                        key={user.id}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            p: 1,
                            borderBottom: "1px solid #ccc",
                            cursor: "pointer",
                            backgroundColor:
                                selectedUser && selectedUser.id === user.id ? "#f0f0f0" : "transparent",
                        }}
                        onClick={() => handleSelect(user)}
                    >
                        <Avatar sx={{ mr: 2 }}>{user.name.charAt(0)}</Avatar>
                        <Box>
                            <Typography variant="subtitle1">{user.name}</Typography>
                            <Typography variant="body2">{user.email}</Typography>
                        </Box>
                    </Box>
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                    disabled={!selectedUser}
                >
                    Add
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default AddUserModal;